export default {
	options: {
		allVehicles: {
			id: 'all',
			label: 'All vehicles',
		},
		filteredVehicles: {
			id: 'filtered',
			label: 'Filtered vehicles',
		},
	},
	title: 'Download vehicles',
};
